//PROJECT'S IMAGE
    // hotel and go
import hotel1 from '../../assets/hotelandgo/hotel&go-booking.webp';
import hotel2 from '../../assets/hotelandgo/hotel&go-dashboard.webp';
import hotel3 from '../../assets/hotelandgo/hotel&go-features.webp';
import hotel4 from '../../assets/hotelandgo/hotel&go-homescreen.webp'; 
import hotel5 from '../../assets/hotelandgo/hotel&go-login.webp';
import hotel6 from '../../assets/hotelandgo/hotel&go-roomview.webp';
import hotel7 from '../../assets/hotelandgo/hotel&go-search.webp';
    // supernova
import ecom1 from '../../assets/supernova/supernova-homescreen.webp';
    // bank
import bank1 from '../../assets/bank/bank-homescreen.webp';
import bank2 from '../../assets/bank/bank-cta.webp';
import bank3 from '../../assets/bank/bank-testimonies.webp';
    // katoclinic
import clinic1 from '../../assets/katoclinic/kato-appointment.webp';
import clinic2 from '../../assets/katoclinic/kato-homescreen.webp';
import clinic3 from '../../assets/katoclinic/kato-specialists.webp';
    // gpt
import gpt1 from '../../assets/gpt/gpt-homescreen.webp';
import gpt2 from '../../assets/gpt/gpt-blog.webp';
import gpt3 from '../../assets/gpt/gpt-footer.webp';
    // resto
import resto1 from '../../assets/resto/resto-booking.webp';
import resto2 from '../../assets/resto/resto-chef.webp';
import resto3 from '../../assets/resto/resto-cta.webp';
import resto4 from '../../assets/resto/resto-homescreen.webp';
import resto5 from '../../assets/resto/resto-menu.webp';
    // weather
import weather1 from '../../assets/weather/weather1.webp';
import weather2 from '../../assets/weather/weather2.webp';
import weather3 from '../../assets/weather/weather3.webp';
    // gallery
import gallery1 from '../../assets/gallery/gallery1.webp';
import gallery2 from '../../assets/gallery/gallery2.webp';
import gallery3 from '../../assets/gallery/gallery3.webp';

//TECHNO LOGOS
import ReactLogo from '../../assets/react.png';
import CssLogo from '../../assets/css.png';
import HtmlLogo from '../../assets/html.png';
import JsLogo from '../../assets/javascript.png';
import ExpressLogo from '../../assets/express.png';
import ReduxLogo from '../../assets/redux.png';
import SassLogo from '../../assets/sass.png';
import NodeLogo from '../../assets/node.png';
import TailwindLogo from '../../assets/Tailwind.png';
import MongodbLogo from '../../assets/mongodb.png';
//LINK ICONS
import {AiOutlineGithub, AiOutlineLink} from 'react-icons/ai'

export const projectData = {
    fullstack: [
        {
            id : 'FS1',
            name: 'Hotel & Go',
            image: hotel4,
            desc : 'Booking.com-inspired project with streamlined reservations and practical functionality. Elevate your travel platform for an efficient, user-friendly experience.',
            tech : [{
                logo: MongodbLogo,
                title: 'MongoDB'
            },{
                logo: ExpressLogo,
                title: 'ExpressJs'
            },{
                logo: ReactLogo,
                title: 'ReactJs'
            },{
                logo: NodeLogo,
                title: 'NodeJs'
            },{
                logo: ReduxLogo,
                title: 'Redux toolkit'
            },{
                logo: JsLogo,
                title: 'Javascript'
            }],
            subtitle:'My first fullstack project',
            details: [
                {
                title:"Authentication",
                subtitle:"Create your account",
                description:[
                    "Sign up or log in to book a room.",
                    "A test account is provided for beta version testing."
                ],
                image: hotel5,
                },
                {
                title:"Home page",
                subtitle:"Find a hotel for your next getaway",
                description:[
                    "Explore trending destinations, browse by property type, and check out accomodations recommmended on the page."
                ],
                image: hotel3,
                },
                {
                title:"Search bar",
                subtitle:"Explore our hotel database",
                description:[ 
                    "Discover available accommodations for the desired destination, precise the dates and number of guests, and filter your results by price.",
                    "Only 4 destinations available (Madrid, Berlin, London, Paris) "
                ],
                image: hotel7,
                },
                {
                title:"Property page",
                subtitle:"Learn more about the selected hotel",
                description:[
                    "Every page contains details about the hotel, including its address, room rates, proximity to the city center, and images of the rooms." 

                ],
                image: hotel6,
                },
                {
                title:"Room booking",
                subtitle:"Select and book a room",
                description:[
                    "Learn more about available rooms at the hotel you picked and make a reservation.",
                    "Availability depends on the selected dates. "
                ],
                image: hotel1,
                },
                {
                title:" Admin dashboard ",
                subtitle:"Manage property data and view statistics",
                description:[
                    "A user-friendly backend portal designed for adding hotels and rooms to the database, managing user accounts, and monitoring statistics."
                ],
                image: hotel2,
                }
            ],
            links: [
                {
                link:"https://hotelandgo-client.netlify.app/",
                logo: <AiOutlineLink/> ,
                title:"Website",
                subtitle:"Hotel&Go",
                },
                {
                link:"https://hotelandgo-admin.netlify.app",
                logo:<AiOutlineLink/>,
                title:"Dashboard",
                subtitle:"Hotel&Go",
                },
                {
                link:"https://github.com/Akaid0/hotel-and-go",
                logo:<AiOutlineGithub />,
                title:"Repository",
                subtitle:"Hotel&Go",
                }
            ]
        }, {
            id : 'FS2',
            name: 'Supernova',
            image: ecom1,
            desc : 'A multi-vendor e-commerce website with an interactive wishlist and payment system, product comparison tool, and authentication.',
            tech : [{
                        logo: MongodbLogo,
                        title: 'MongoDB'
                    },{
                        logo: ExpressLogo,
                        title: 'ExpressJs'
                    },{
                        logo: ReactLogo,
                        title: 'ReactJs'
                    },{
                        logo: NodeLogo,
                        title: 'NodeJs'
                    },{
                        logo: ReduxLogo,
                        title: 'Redux toolkit'
                    },{
                        logo: JsLogo,
                        title: 'Javascript'
                    }],
            subtitle:'First fullstack project',
            nothing: 'Coming soon',
            details: [
                {
                title:"Credentials",
                subtitle:"You can create your own personnal account !",
                description:["backend signup/login/logout possibility making your dreams come true, more text blablabla balblabla blablabla blablabla blablabla balblabla blablabla blablabla blablabla balblabla blablabla blablabla"],
                image: ecom1,
                },
                {
                title:"Wishlist/product compare/ cart/ payment",
                subtitle:"A complete e-commerce functionnality",
                description:["Saved in a database, create your own wishlist, compare the products options and proceed an order throught the end."],
                image: ecom1,
                },
                {
                title:"Dashboard",
                subtitle:"Manage the products, the blog's artciles and the orders",
                description:["In an simple dashboard, reach to find all the orders passed by customers, update their statues, create new products and write new blog articles all in the sale place"],
                image: ecom1,
                }
            ],
            links: [
                {
                link:"#",
                logo: <AiOutlineLink/> ,
                title:"Website",
                subtitle:"Supernova",
                },
                {
                link:"#",
                logo:<AiOutlineLink/>,
                title:"Dashboard",
                subtitle:"Supernova",
                },
                {
                link:"https://github.com/Akaid0?tab=repositories",
                logo:<AiOutlineGithub />,
                title:"Repository",
                subtitle:"Supernova",
                }
            ]
        }
    ],
    frontend: [
        {
            id : 'FE1',
            name: 'Bistro Café',
            image: resto4,
            desc : "I survived 10 years in hospitality, so obviously it haunts me in my sleep. Check it out, hope you'll order something nice.",
            tech : [{
                logo: HtmlLogo,
                title: 'HTML'
            },{
                logo: CssLogo,
                title: 'CSS'
            },{
                logo: JsLogo,
                title: 'Javascript'
            },{
                logo: ReactLogo,
                title: 'ReactJs'
            },{
                logo: TailwindLogo,
                title: 'Tailwind'
            } ],
            subtitle:'A beautiful restaurant website',
            details: [
                {
                title:"Hero section",
                subtitle:"What makes a good homepage ?",
                description:["The homepage is like a restaurant's lobby, your first greeting! It's all about making you feel welcome and drawn in effortlessly. Find what you need – easy navigation, social links, and cool stuff to click on and join in!"],
                image: resto4,
                },
                {
                title:"The menu",
                subtitle:"or how to make sure user gets hungry ?",
                description:["The menu is the main event, your booking trigger, and a sneak peek at your next order. Clear, concise, and always tempting."],
                image: resto5,
                },
                {
                title:"The chef",
                subtitle:"Meet the team",
                description:["Beyond the menu, meet the creative minds crafting your delectable experience. Discover their ethos, the passion that fuels their culinary artistry, and the drive behind each enticing creation."],
                image: resto2,
                },
                {
                title:"The booking form",
                subtitle:"Make them click !",
                description:["The core of the experience — just a click away to ensure your engagement. It's a delicate balance between guaranteeing your booking and ensuring you'll be there to enjoy."],
                image: resto1,
                },
                {
                title:"The footer",
                subtitle:"Cherry on top or waste of effort ?",
                description:[" Often overlooked, the footer is a powerful tool for enhanced user interaction and engagement. It's the perfect space for providing additional information or sparking engagement through a compelling call-to-action, perhaps for a newsletter."],
                image: resto3,
                }
            ],
            links: [
                {
                link:"https://bistrocafepraha.netlify.app/",
                logo:<AiOutlineLink/>,
                title:"Webiste",
                subtitle:"Bistro Café",
                },
                {
                link:"https://github.com/Akaid0/BistroCafe",
                logo:<AiOutlineGithub />,
                title:"Repository",
                subtitle:"Bistro Café",
                },
            ]
            
        },{
            id : 'FE2',
            name: 'Kato Clinic',
            image: clinic2,
            desc : 'Discover all the health services of Kato Clinic, get to know medical professionals, and make an appointment directly on the user-friendly website.',
            tech : [{
                logo: HtmlLogo,
                title: 'HTML'
            },{
                logo: JsLogo,
                title: 'Javascript'
            },{
                logo: ReactLogo,
                title: 'ReactJs'
            },{
                logo: SassLogo,
                title: 'Sass'
            }],
            subtitle:'Your Ideal Healthcare Partner.',
            details: [
                {
                title:"Made with Sass",
                subtitle:"Appealing and optimized",
                description:["Implementing Sass taught me the importance of preparing my designs in advance.", "Paired with React, Sass helps get cleaner code and maintain it with ease."],
                image: clinic2,
                },
                {
                title:"Make an appointment",
                subtitle:"Multiple contact options available",
                description:["Reach out to our medical professionals via socials featured in their individual cards or use the form powered by Formspree API. "],
                image: clinic1,
                },
                {
                title:"Responsive",
                subtitle:"Make your appointment on any device !",
                description:["Enjoy a smooth experience on any device! Our platform is optimized for desktops, tablets, and smartphones, ensuring fluid access and user-friendly design."],
                image: clinic3,
                }
            ],
            links: [
                {
                link:"https://katoclinic.netlify.app/",
                logo:<AiOutlineLink/>,
                title:"Website",
                subtitle:"Kato Clinic",
                },
                {
                link:"https://github.com/Akaid0/SASS-Hospital",
                logo:<AiOutlineGithub />,
                title:"Repository",
                subtitle:"Saas Hospital",
                },
            ]
        }, {
            id : 'FE3',
            name: 'Gutenberg',
            image: bank1,
            desc : 'Made with TailwindCSS and Vite, this banking webpage  showcases how thoughtful design choices influence the user experience and overall aesthetic of the site.',
            tech : [{
                logo: HtmlLogo,
                title: 'HTML'
            },{
                logo: JsLogo,
                title: 'Javascript'
            },{
                logo: ReactLogo,
                title: 'ReactJs'
            },
            {
                logo: CssLogo,
                title: 'CSS'
            },{
                logo: TailwindLogo,
                title: 'Tailwind'
            }],
            subtitle:"Your banker's bank",
            details: [
                {
                title:"TailwindCSS",
                subtitle:"Achieving mastery",
                description:["With the Tailwind CSS framework, you can swiftly bring any design idea to life. It enables efficient and concise creation of diverse designs, turning imagination into reality.", "For this project, I delved into Figma and Tailwind to explore their combined potential, gaining a comprehensive understanding of the vast possibilities they offer."],
                image: bank1,
                },
                {
                title:"Modern UI/UX design",
                subtitle:"Sober and audacious",
                description:["Recent design aesthetics seamlessly blend vibrant gradients, minimalist look, and compelling call-to-action buttons.","Testimonials add authenticity, while smooth animations and good color palettes elevate the user experience."],
                image: bank2,
                },
                {
                title:"Responsive",
                subtitle:"Satisfactory responsiveness on all devices",
                description:["Tailwind, the responsive design powerhouse, simplifies adaptability with its utility-first approach.","Its well-organized classes empower easy layout crafting, ensuring a smooth experience across devices. It's the key ingredient for responsive and visually consistent web design."],
                image: bank3,
                }
            ],
            links: [
                {
                link:"https://gutenbergvault.netlify.app/",
                logo:<AiOutlineLink/>,
                title:"Website",
                subtitle:"Hoobank",
                },
                {
                link:"https://github.com/Akaid0/modern-bank",
                logo:<AiOutlineGithub />,
                title:"Repository",
                subtitle:"Modern bank",
                },
            ]
        }, {
            id : 'FE4',
            name: 'GPT-3',
            image: gpt1,
            desc : 'A presentation of the brand new but already old .. GPT-3 ! Are you tired of it already ? Yeah me too. But check on it, the website is nice.',
            tech : [{
                logo: HtmlLogo,
                title: 'HTML'
            },{
                logo: CssLogo,
                title: 'CSS'
            },{
                logo: JsLogo,
                title: 'Javascript'
            },{
                logo: ReactLogo,
                title: 'ReactJs'
            },{
                logo: TailwindLogo,
                title: 'Tailwind'
            } ],
            subtitle:'',
            details: [
                {
                title:"Home page",
                subtitle:"Why is it crucial ?",
                description:["It's the first impression, setting the tone for user experience, conveying your brand, and guiding visitors to relevant content."],
                image: gpt1,
                },
                {
                title:"Blog section",
                subtitle:"The hidden gem of any webpage",
                description:["A blog section is vital for dynamic engagement, offering a platform to share insights, build authority, and connect with your audience. It enhances SEO, fosters trust, and keeps your website actual and relevant."],
                image: gpt2,
                },
                {
                title:"Footer",
                subtitle:"A small space with significant impact",
                description:[" A footer call-to-action is a strategic closing note, guiding visitors to take the next step. It boosts conversions, encourages engagement, and provides a seamless path for users to connect, subscribe, or explore further. "],
                image: gpt3,
                }
            ],
            links: [
                {
                link:"https://futureisnow.netlify.app/",
                logo:<AiOutlineLink/>,
                title:"Website",
                subtitle:"GPT-3",
                },
                {
                link:"https://github.com/Akaid0/GPT3",
                logo:<AiOutlineGithub />,
                title:"Repository",
                subtitle:"GPT-3",
                },
            ]
        }
    ],
    component: [
        {
            id : 'C1',
            name: 'Cool Gallery',
            image: gallery1,
            desc : " I was researching the parallax effect and found this gallery, I recreated it for upcoming projects. Original design by Camille Mormal. ",
            tech : [{
                logo: HtmlLogo,
                title: 'HTML'
            },{
                logo: CssLogo,
                title: 'CSS'
            },{
                logo: JsLogo,
                title: 'Javascript'
            } ],
            subtitle:'Turn images into a dynamic carousel ',
            details: [
                {
                    title:"Easy navigation",
                    subtitle:"Slide both ways",
                    description:["Experience satisfying browsing motion with grab and slide for smooth navigation through the gallery."],
                    image: gallery1,
                },
                {
                    title:"Unlimited number of images",
                    subtitle:"Show it all",
                    description:["Highlight your products or services by presenting it from various perspectives and showcasing their diverse features. "],
                    image: gallery2,
                },
                {
                    title:" A little surprise for you",
                    subtitle:"",
                    description:["Every gallery needs an attendant, right?"],
                    image: gallery3,
                }
            ],
            links: [
                {
                link:"https://cool-gallery.netlify.app/",
                logo:<AiOutlineLink/>,
                title:"Website",
                subtitle:"Cool Gallery",
                },
                {
                link:"https://github.com/Akaid0/CoolGallery",
                logo:<AiOutlineGithub />,
                title:"Repository",
                subtitle:"Cool Gallery",
                },
            ]
            
        },{
            id : 'C2',
            name: 'Weather App',
            image: weather1,
            desc : 'Yes, again. You see it everywhere. This one is not especially complex, I just work on it sometimes to train my skills.',
            tech : [{
                logo: HtmlLogo,
                title: 'HTML'
            },{
                logo: CssLogo,
                title: 'CSS'
            },{
                logo: JsLogo,
                title: 'Javascript'
            } ],
            subtitle:'',
            details: [
                {
                    title:"Your daily forecast",
                    subtitle:"Short or pants today ?",
                    description:["Based on your location, check on the weather conditions in detail wherever you are."],
                    image: weather1,
                },
                {
                    title:"OpenWeaterMap API",
                    subtitle:"Simple and fast",
                    description:["When building this webapp I learned how to use APIs and manipulate data, including precise dates and locations. "],
                    image: weather2,
                },
                {
                    title:"Aesthetically pleasing",
                    subtitle:"Don't get bored",
                    description:["Enjoy a new background each time you visit and discover wonders of the world and beautiful landscapes."],
                    image: weather3,
                }
            ],
            links: [
                {
                link:"https://akaid0.github.io/Weather-app/",
                logo:<AiOutlineLink/>,
                title:"Web app",
                subtitle:"Meteo App",
                },
                {
                link:"https://github.com/Akaid0/Weather-app",
                logo:<AiOutlineGithub />,
                title:"Repository",
                subtitle:"Meteo App",
                },
            ]
        }
    ],
}